import React from 'react';
import MainHeading from '../Common/MainHeading';
import PlanBox from '../Common/PlanBox';
import { useLocale } from '../../localization/LocaleContext';

export default function Price() {
    const { t } = useLocale();

    return(
        <section className="sp-90">
            <div className="container">
                <div className="row">
                    <MainHeading headingName={t('pricing.heading')} />
                    <p className=" text-center">{t('pricing.subheading')}</p>
                    {/* <p className="text-center mb-30"> <span className="h-bold">MONTHLY - YEARLY</span>(switch button to change prices accordingly, prices below are monthly</p> */}
                <PlanBox/>
                </div>   
            </div>           
        </section>
    )
}